import { useController } from 'react-hook-form';
import { TagGroup } from 'ui/tags';
import { TagGroupProps } from 'ui/tags/TagGroup';
import { FieldProps } from './types';

type TagGroupFieldProps = FieldProps & Omit<TagGroupProps, 'onUpdate' | 'value'>;

export const TagGroupField = ({ name, defaultValue, ...rest }: TagGroupFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue,
  });

  return <TagGroup {...rest} value={value} onUpdate={onChange} />;
};
